import { Field } from "./Field";

export function Slider({
  label, value, onChange, min = 0, max = 100, step = 1, unit = "", hint,
}: {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  unit?: string;
  hint?: string;
}) {
  return (
    <Field hint={hint}>
      <div className="flex items-center justify-between mb-1">
        <span className="text-sm text-haze-200">{label}</span>
        <span className="text-xs font-mono text-accent tabular-nums">
          {Number.isInteger(value) ? value : value.toFixed(2).replace(/0$/, "")}
          {unit}
        </span>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(event) => onChange(Number(event.target.value))}
        className="w-full"
      />
    </Field>
  );
}
